import {
  axios_institute_private,
  axios_ozonetel,
  axios_openSearch,
} from "../../../../api/setup.intersepter";
import {
  AddAgentsDTO,
  AddMetaAccountDTO,
  CallDispositionDTO,
  ConnectOzonetelDTO,
  CreateAppTokenDTO,
  CreateStreamDTO,
  MapFieldsDTO,
  NurturePayDTO,
  CreateMetaAddonPaymentTypes,
  EditCreditDataTypes,
  MetaContactListTypes,
} from "./types";

export const ConnectOzonetel = (body: ConnectOzonetelDTO) => {
  return axios_institute_private({
    method: "POST",
    url: `/institution/apps`,
    data: body,
  });
};

export const DeactivateOzonetel = (id: string) => {
  return axios_institute_private({
    method: "DELETE",
    url: `/institution/apps?instituteId=${id}&appCode=OZONETEL`,
    data: id,
  });
};

export const AddOzonetelAgents = (body: AddAgentsDTO) => {
  return axios_institute_private({
    method: "POST",
    url: `/institution/ozonetel/agent`,
    data: body,
  });
};

export const GetAppsByInstitute = (id: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/institution/apps?instituteId=${id}`,
  });
};

export const ValidateAgentId = (
  agentId: string,
  instituteId: string,
  apiKey: string,
  userName: string
) => {
  return axios_institute_private({
    method: "GET",
    url: `institution/ozonetel/agent?checkAgentStatus=true&agentId=${agentId}&instituteId=${instituteId}&apiKey=${apiKey}&userName=${userName}`,
  });
};

export const UpdateOzonetelAgents = (body: AddAgentsDTO) => {
  return axios_institute_private({
    method: "PUT",
    url: `/institution/ozonetel/agent`,
    data: body,
  });
};

export const CallLead = (
  apiKey: string,
  userName: string,
  agentId: string,
  campaignName: string,
  leadNumber: string,
  instituteId: string,
  leadId: string,
  appEnv: string,
  cbid: string,
  cbn: string
) => {
  return axios_ozonetel({
    method: "GET",
    url: `https://in1-ccaas-api.ozonetel.com/CAServices/AgentManualDial.php?api_key=${apiKey}&username=${userName}&agentID=${agentId}&campaignName=${campaignName}&customerNumber=${leadNumber}&UCID=true&format=json&uui=CBID%23${cbid}%23CBN%23${cbn}%23INSTID%23${instituteId}%23ENQID%23${leadId}%23ENV%23${appEnv}`,
  });
};

export const InstallNurturePay = (body: NurturePayDTO) => {
  return axios_institute_private({
    method: "POST",
    url: `/institution/apps`,
    data: body,
  });
};

export const CallLeadStatus = (apiKey: string, userName: string) => {
  return axios_ozonetel({
    method: "GET",
    url: `https://in1-ccaas-api.ozonetel.com/cloudAgentRestAPI/index.php/CloudAgent/CloudAgentAPI/getAgentLogins?api_key=${apiKey}&username=${userName}&format=json`,
  });
};

export const LeadCallDispositionForm = (body: CallDispositionDTO) => {
  return axios_institute_private({
    method: "POST",
    url: `/nurture/lead/addDispostion`,
    data: body,
  });
};

export const SetOzonetelDisposition = (
  apiKey: string,
  userName: string,
  agentId: string,
  did: string,
  ucid: string,
  reasons: string
) => {
  const encodedReasons = encodeURIComponent(reasons);
  return axios_ozonetel({
    method: "POST",
    url: `https://in1-ccaas-api.ozonetel.com/CAServices/Disposition/DispositionAPIV2.php?customer=${userName}&agentID=${agentId}&apiKey=${apiKey}&did=${did}&ucid=${ucid}&action=set&disposition=${encodedReasons}`,
  });
};

export const CreateAppToken = (body: CreateAppTokenDTO) => {
  return axios_institute_private({
    method: "POST",
    url: `/institute/token`,
    data: body,
  });
};

export const GetAppToken = (id: string, appName: string) => {
  return axios_institute_private({
    method: "GET",
    url: `institute/token?instituteId=${id}&appName=${appName}`,
  });
};

export const AppIntegrateToNurture = (body: ConnectOzonetelDTO) => {
  return axios_institute_private({
    method: "POST",
    url: `/institution/apps`,
    data: body,
  });
};

export const UninstallTokenGeneratedApp = (id: string, appName: string) => {
  return axios_institute_private({
    method: "DELETE",
    url: `institute/token?instituteId=${id}&appName=${appName}`,
    data: id,
  });
};

export const GetSubmerchantList = (id: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/submerchant?instituteId=${id}`,
  });
};

export const DeleteSubmerchant = (body: any) => {
  return axios_institute_private({
    method: "DELETE",
    url: `/submerchant`,
    data: body,
  });
};

export const AddSubmerchantList = (body: any) => {
  return axios_institute_private({
    method: "POST",
    url: `/submerchant`,
    data: body,
  });
};

export const UpdateSubmerchantList = (body: any) => {
  return axios_institute_private({
    method: "PUT",
    url: `/submerchant`,
    data: body,
  });
};

export const GetMetaIntegratedAccounts = (id: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/metaIntegration?instituteId=${id}&action=metaIntegratedAccounts`,
  });
};

export const GetMetaAccountPages = (id: string, metaAccountId: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/metaIntegration?instituteId=${id}&action=page&metaAccountId=${metaAccountId}`,
  });
};

export const GetMetaAdAccount = (id: string, metaAccountId: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/metaIntegration?instituteId=${id}&action=adAccount&metaAccountId=${metaAccountId}`,
  });
};
export const GetMetaPageForms = (
  id: string,
  metaAccountId: string,
  pageId: string
) => {
  return axios_institute_private({
    method: "GET",
    url: `/metaIntegration?pageId=${pageId}&instituteId=${id}&metaAccountId=${metaAccountId}`,
  });
};

export const AddMetaAccount = (body: AddMetaAccountDTO) => {
  return axios_institute_private({
    method: "POST",
    url: `/metaIntegration?action=metaIntegrate`,
    data: body,
  });
};

export const AddMetaStream = (body: CreateStreamDTO) => {
  return axios_institute_private({
    method: "POST",
    url: `/metaIntegration`,
    data: body,
  });
};

export const EditMetaStream = (body: CreateStreamDTO) => {
  return axios_institute_private({
    method: "PUT",
    url: `/metaIntegration`,
    data: body,
  });
};

export const GetStreamFieldMapping = (id: string, streamId: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/metaIntegration?instituteId=${id}&streamId=${streamId}`,
  });
};
export const GetStreams = (id: string, status: string, branchId: string) => {
  let url = `metaIntegration?instituteId=${id}&action=listStream`;
  if (status) {
    url += `&status=${status}`;
  }
  if (branchId) {
    url += `&branchId=${branchId}`;
  }
  return axios_institute_private({
    method: "GET",
    url: url,
  });
};

export const GetStreamsForBranch = (branchId: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/metaIntegration?branchId=${branchId}&action=branchStreams`,
  });
};
export const GetMetaFields = (streamId: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/metaIntegration?action=metaStreamFormFields&streamId=${streamId}`,
  });
};

export const GetMetaDefaultFields = () => {
  return axios_institute_private({
    method: "GET",
    url: `/metaIntegration?action=listMetaDefaultFields`,
  });
};
export const MapMetaFields = (body: MapFieldsDTO) => {
  return axios_institute_private({
    method: "POST",
    url: `/metaIntegration?action=fieldMapping`,
    data: body,
  });
};
export const UpdateMapMetaFields = (body: MapFieldsDTO) => {
  return axios_institute_private({
    method: "PUT",
    url: `/metaIntegration?action=fieldMapping`,
    data: body,
  });
};

export const CreateMetaAddonPayement = (body: CreateMetaAddonPaymentTypes) => {
  return axios_institute_private({
    method: "POST",
    url: `/metaIntegration?action=createMetaAddOnPaymentLink`,
    data: body,
  });
};

export const GetCreditMetaDistribution = (instituteId: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/metaIntegration?instituteId=${instituteId}&action=creditDistribution`,
  });
};

export const EditCredit = (body: EditCreditDataTypes) => {
  return axios_institute_private({
    method: "PUT",
    url: `/metaIntegration?action=creditEdit`,
    data: body,
  });
};
export const GetStreamById = (streamId: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/metaIntegration?action=streamById&streamId=${streamId}`,
  });
};

export const GetMetaContactList = (body: MetaContactListTypes) => {
  return axios_institute_private({
    method: "POST",
    url: `/metaIntegration?action=listMetaContact`,
    data: body,
  });
};

export const MetaContactToLead = (body: any) => {
  return axios_institute_private({
    method: "POST",
    url: `/metaIntegration?action=metaContactToLead`,
    data: body,
  });
};

export const DeleteMetaAccount = (id: string, accountId: string) => {
  return axios_institute_private({
    method: "DELETE",
    url: `/metaIntegration?instituteId=${id}&metaAccountId=${accountId}`,
  });
};

export const UpdateMetaStreamStatus = (status: string, streamId: string) => {
  return axios_institute_private({
    method: "PUT",
    url: `/metaIntegration?status=${status}&streamId=${streamId}`,
  });
};

export const GetMetaContact_list = (body: any) => {
  return axios_openSearch({
    method: "POST",
    url: `/elastic_search/nurtureSearch`,
    data: body,
  });
};
export const DeleteStream = (streamId: any) => {
  return axios_institute_private({
    method: "DELETE",
    url: `/metaIntegration?streamId=${streamId}`,
  });
};

export const InstallEdufin = (body: any) => {
  return axios_institute_private({
    method: "POST",
    url: `/institution/apps`,
    data: body,
  });
};

export const DownloadEdufin = (body: any) => {
  return axios_institute_private({
    method: "POST",
    url: `/instituteEdufinLoanApplication`,
    data: body,
  });
};

export const DeleteEdufin = (id: string) => {
  return axios_institute_private({
    method: "DELETE",
    url: `/instituteEdufinLoanApplication?id=${id}`,
  });
};

export const GetEdufinData = (instituteId: string, id?: string) => {
  let url = `/instituteEdufinLoanApplication?instituteId=${instituteId}`;
  if (id) {
    url += `&id=${id}`;
  }
  return axios_institute_private({
    method: "GET",
    url: url,
  });
};

export const SaveEdufinData = (body: any) => {
  return axios_institute_private({
    method: "POST",
    url: `/instituteEdufinLoanApplication`,
    data: body,
  });
};
